























import {
  generateRequirementsList,
  ORDERED_REQUIREMENT_KEYS,
  generateFormattedRequirements
} from '../order-requirements'

export default {
  props: {
    order: { type: Object, required: true }
  },
  computed: {
    requirements() {
      return generateRequirementsList(this.order)
    },
    requiresPalletExchange() {
      return (
        this.requirements[0] && this.requirements[0].includes(ORDERED_REQUIREMENT_KEYS[0])
      )
    },
    formattedRequirements() {
      return this.generateFormattedRequirements(this.requirements)
    },
    tooltip() {
      const { length } = this.requirements
      if (!length) return ''
      const formattedList = this.requirements.slice(2, length).map(key => this.$t(key))
      const tooltipText = formattedList.join(', ')
      return tooltipText
    }
  },
  methods: {
    generateFormattedRequirements
  }
}
